<template>
	<section>
		<Drawer title="选择人员" placement="right" :mask-closable=false v-model="userVisible" width="35%" @on-close="close"
			style="z-index:9999" class="drawer1">
			<div style="margin-left:15px;margin-bottom:80px;margin-top:10px">
				<el-input placeholder="输入关键字过滤" prefix-icon="el-icon-search" v-model="filterText1"
					style="width: 100%;margin-bottom:10px" size="small" clearable></el-input>
				<el-tree :data="treeList" :filter-node-method="filterNode1" show-checkbox node-key="id" ref="tree0"
					:props="{label:'name',children:'list'}" @check="checkChange" :default-checked-keys="check_ids">
				</el-tree>
			</div>
			<div class="demo-drawer-footer1" style="width:35%;">
				<el-button type="text" style="float:left">{{select_number>2?'提示：不能大于'+select_number+'人':''}}</el-button>
				<el-button type="" @click="close" style="margin-right:20px;">取 消</el-button>
				<el-button type="primary" @click="getCheckList()" style="margin-right:20px;">确 定</el-button>
			</div>
		</Drawer>
	</section>
</template>

<script>
	import { user } from "@/api/book";
	import { Drawer } from 'iview';
	export default {

		data() {
			return {
				userVisible: false,
				treeList: [],
				filterText1: '',
				check_ids: [],
				select_number: 0, //可选择的数量，1单选，0不限制
			}
		},
		watch: {
			filterText1(val) {
				this.$refs.tree0.filter(val);
			},
		},

		components: { Drawer },

		methods: {
			filterNode1(value, data) {
				if (!value) return true;
				return data.name.indexOf(value) !== -1;
			},
			checkChange(data, two, three) {
				this.treeList.forEach(r => {
					r.list.forEach(z => {
						if (z.user_id == data.user_id) {
							this.$refs.tree0.store.nodesMap[z.id].checked = this.$refs.tree0.store.nodesMap[data.id].checked
						} else {
							if (this.select_number == 1) {
								this.$refs.tree0.store.nodesMap[z.id].checked = false;
							}
						}
					})
				})
			},

			// 关闭
			close() {
				this.userVisible = false;
				this.$emit('cancelSelect');
			},
			// 确定接收人
			getCheckList() {
				// 获取选中节点数据
				let listS_ret = [];
				this.treeList.forEach((r, i) => {
					listS_ret = this.$refs.tree0.getCheckedNodes();
				})
				listS_ret = listS_ret.filter(e => (!e.class_id || e.class_id == undefined));
				// 去重复
				let check_list = [];
				listS_ret.forEach(r => {
					if (r.user_id && check_list.findIndex(e => e.user_id == r.user_id) == -1) {
						check_list.push(r);
					}
				})
				console.log('sssss', check_list)

				if (check_list.length == 0) {
					this.$message
					return
				}
				if (this.select_number > 1 && check_list.length > this.select_number) {
					check_list = check_list.slice(0, this.select_number)
				}
				console.log('sssss', check_list)
				this.$emit('getCheckList', check_list);
				this.userVisible = false;
			},
			openSelectUser(number, ids,classIds) {
				this.select_number = number
				this.userVisible = true;
				this.check_ids = [];
				this.$nextTick(r => {
					// 清空
					this.$refs.tree0.setCheckedKeys([])
					this.findByRoles1(ids).then(res=>{
						if(classIds){
							this.treeList= this.treeList.filter(v=>classIds.includes(v.class_id))
						}
						
					})
				})
			},

			findByRoles1(ids) {
				this.treeList = [];
				let promise = user.find({ type: 1 });
				return promise.then(res => {
					if (res.data) {
						res.data.forEach((r, i) => {
							r.id = r.class_id == 0 ? '0' + i : r.class_id;
							r.list.forEach(e => {
								e.id = r.id + '_' + e.user_id;
							});
						})
						this.treeList = res.data;

						// 将已有的人员全部选中
						if (ids && ids.length > 0) {
							this.treeList.forEach(r => {
								r.list.forEach(v => {
									if (ids.findIndex(z => z == v.user_id) != -1) {
										this.check_ids.push(v.id);
									}
								})
							})
						}
						return true
					}
				});
			},
		},
		mounted() {
		}
	}
</script>

<style scoped lang="scss">
	.drawer1 /deep/ .ivu-drawer-wrap {
		z-index: 9999;
	}
	.drawer1 /deep/ .ivu-drawer-mask {
		z-index: 9998;
	}
</style>


// WEBPACK FOOTER //
// src/components/common/findUserByRole.vue